import { Builder, builder, withChildren } from '@builder.io/react'
import dynamic from 'next/dynamic'
import { SUBSCRIPTION_BOX_LANDINGS_PAGE } from 'src/constants/subscriptionSources'

export const getBuilderPageContent = async (url: string, locale: string) => {
  const builderContent = await builder
    .get('page', {
      url,
      options: { locale },
      userAttributes: { locale },
      includeUnpublished: true,
    })
    .toPromise()

  return builderContent
}

export const registerBuilderComponents = () => {
  // Factorial open positions component
  Builder.registerComponent(
    dynamic(() => import('client/components/FactorialOpenPositionsIframe')),
    {
      name: 'FactorialOpenPositions',
      inputs: [
        { name: 'width', type: 'string', defaultValue: '100%' },
        { name: 'height', type: 'string', defaultValue: '100%' },
      ],
    }
  )

  // external link
  Builder.registerComponent(withChildren(dynamic(() => import('src/comps/BuilderLink'))), {
    name: 'LinkBlock',
    inputs: [
      { name: 'url', type: 'string', defaultValue: '' },
      {
        name: 'target',
        type: 'string',
        defaultValue: '_self',
        enum: ['_self', '_blank', '_parent', '_top'],
      },
    ],
  })

  Builder.registerComponent(
    dynamic(() => import('src/pages/homeV2/SubscriptionBoxConnected')),
    {
      name: 'NewsletterBox',
      inputs: [
        {
          name: 'source',
          type: 'string',
          defaultValue: SUBSCRIPTION_BOX_LANDINGS_PAGE,
          localized: true,
        },
        {
          name: 'variant',
          type: 'text',
          enum: ['box', 'section', 'minimal'],
          defaultValue: 'section',
          helperText:
            'box/section: Full customization. minimal: Only input + button (no title/description/background)',
        },
        {
          name: 'title',
          type: 'string',
          localized: true,
          showIf: 'options.get("variant") !== "minimal"',
          helperText: 'Custom title (uses default translation if empty)',
        },
        {
          name: 'description',
          type: 'string',
          localized: true,
          showIf: 'options.get("variant") !== "minimal"',
          helperText: 'Custom description (uses default translation if empty)',
        },
        {
          name: 'bgColor',
          type: 'color',
          defaultValue: '#B494F9',
          showIf: 'options.get("variant") !== "minimal"',
          helperText: 'Container background color',
        },
        {
          name: 'buttonText',
          type: 'string',
          localized: true,
          helperText: 'Custom button text (uses default translation if empty)',
        },
        {
          name: 'buttonBgColor',
          type: 'color',
          helperText: 'Custom button background color (uses default if empty)',
        },
        {
          name: 'buttonTextColor',
          type: 'color',
          helperText: 'Custom button text color (uses default if empty)',
        },
      ],
    }
  )

  Builder.registerComponent(
    withChildren(
      // eslint-disable-next-line import/no-relative-packages
      dynamic(() => import('../../../../../packages/uikit/src/Organisms/BannerProperties'))
    ),
    {
      name: 'BannerProperties',
      inputs: [
        { name: 'bannerId', type: 'string', defaultValue: '' },
        {
          name: 'checkInOffset',
          type: 'number',
          defaultValue: 0,
          min: 0,
          helperText: 'Number of days to add to the check-in date from today (TTC)',
        },
      ],
    }
  )

  Builder.registerComponent(
    // eslint-disable-next-line import/no-relative-packages
    dynamic(() => import('../../../../../packages/uikit/src/Organisms/TopDestinations/Connected')),
    {
      name: 'BannerDestinations',
      inputs: [{ name: 'bannerId', type: 'string', defaultValue: '' }],
    }
  )
}
